import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const createEstablishmentLeadSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho mínimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  observations: z.string().min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
  general_information: z.object({
    cnpj: z.string({ message: 'Campo obrigatório' }).min(18, {message: 'Insira um CNPJ válido'}).max(18, {message: 'Insira um CNPJ válido'}),
    commercial_kind: optionSchema,
  }),
  contacts: z.object({
    full_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho mínimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
    role_in_company: z.string().optional(),
    email: z.string().min(1, 'Campo e-mail é obrigatório').email('Use um formato de e-mail válido'),
    phone: z.object({
      number: z.string().min(1, {message: 'Campo obrigatório'}),
    }),
  })
})

export type CreateEstablishmentLeadValidationSchema = z.infer<typeof createEstablishmentLeadSchema>
